export enum FilterActions {
  Reset = "reset",
  Remove = "remove",
  Set = "set",
  Apply = "apply",
}
